import * as React from 'react';
import TextField from '@mui/material/TextField';
import { Autocomplete, ListItem } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useGetAllSimpleCustomers } from './Hook';



export default function AsyncCustomerSelect({
    setFieldValue = () => { },
    multiple = false,
    mode = 'add',
    formFieldKey = '',
    setMainCustomerSelected = () => { },
    mainCustomerSelected = []
}
) {
    const listboxRef = React.useRef(null);

    const [options, setOptions] = React.useState([]);
    const [hasMore, setHasMore] = React.useState(true);
    const [queryBody, setQueryBody] = React.useState({
        page: 1,
        pageSize: 20,
        orderByField: "",
        orderByDescending: true,
        getExcel: true,
        searchTerm: ""
    });

    const { data: fetchedData, isLoading: getOrdersLoading } = useGetAllSimpleCustomers(queryBody);

    React.useEffect(() => {
        if (fetchedData) {
            // توجه: اگر fetchedData یک آبجکت است و آرایه داخل خاصیتی (مثل data) قرار دارد، اینجا را اصلاح کنید
            const newItems = fetchedData || [];

            if (queryBody.page === 1) {
                setOptions(newItems);
            } else {
                setOptions(prev => [...prev, ...newItems]);
            }

            if (newItems.length < queryBody.pageSize) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }
        }
    }, [fetchedData, queryBody.page]);

    const handleScroll = (event) => {
        const listboxNode = listboxRef.current;
        if (!listboxNode || !hasMore || getOrdersLoading) return;
        const { scrollTop, scrollHeight, clientHeight } = listboxNode;

        if (
            scrollHeight - scrollTop <= clientHeight + 20 &&
            !getOrdersLoading
        ) {
            setQueryBody(prev => ({ ...prev, page: prev.page + 1 }));
        }




    };

    const handleInputChange = (event, newInputValue, reason) => {
        if (reason === 'input') {
            setQueryBody(prev => ({
                ...prev,
                page: 1,
                searchTerm: newInputValue
            }));
            setHasMore(true);
        }
    };

























    return (
        <Autocomplete
            fullWidth
            multiple={multiple}
            // sx={{
            //     color: "#1E6AFD",
            //     backgroundColor: "#1E6AFD1A",
            //     fontSize: "0.7rem"

            // }}
            sx={{p:'0px'}}

            ChipProps={{
                sx: {
                    color: "#1E6AFD",
                    p:'0px',
                    m:'0px',
                    backgroundColor: "#1E6AFD1A",
                    "& .MuiChip-label": { fontFamily: "yekan", fontSize: "0.7rem" },
                    " & ..muirtl-11kte86-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":{padding:'0px'}
                },
            }}

            options={options}
            onChange={(event, value, reason) => {
                if (reason === "clear") {
                    // setCustomerSelected(multiple ? [] : null);
                    setMainCustomerSelected(multiple ? [] : null);
                    setQueryBody(prev => ({ ...prev, searchTerm: "" }));
                    return;
                }

                // setCustomerSelected(value);

                setMainCustomerSelected(value);

                if (!multiple) {
                    setFieldValue?.(formFieldKey, value?.id);
                }
            }}



            value={mainCustomerSelected}
            // --- تنظیمات مهم بر اساس ساختار داده شما ---
            getOptionLabel={(option) => option?.customerName || ""}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            // ----------------------------------------------

            loading={getOrdersLoading}
            filterOptions={(x) => x}
            onInputChange={handleInputChange}


            ListboxProps={{
                ref: listboxRef,
                onScroll: handleScroll,
                sx: { maxHeight: 300 }
            }}

            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    label="جست و جوی مشتری"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {getOrdersLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}

            renderOption={(props, option) => (
                <ListItem {...props} key={option.id} sx={{ fontSize: "0.75rem" }}>
                    {option.customerName}
                </ListItem>
            )}
        />
    );
}